const rotationCategories = {
  100: "rotacion_carro",
  150: "rotacion_moto",
  120: "rotacion_bicicleta",
};
const text = (value) => (value == null ? "" : String(value).trim());
const isParkingVisit = (record) =>
  record &&
  (Object.prototype.hasOwnProperty.call(record, "CodigoTarjeta") ||
    Object.prototype.hasOwnProperty.call(record, "HoraEntrada") ||
    Object.prototype.hasOwnProperty.call(record, "HoraSalida"));

// CodigoTarjeta identifica la tarjeta y puede repetirse en visitas diferentes.
export function normalizeParkingVisits(records) {
  return records.map((record) => {
    if (!isParkingVisit(record)) return record;
    const ticketType = text(record.TipoTarjeta);
    const ticketName = text(record.NombreTipoTarjeta);
    const category = /^vip(?:\b|_)/i.test(ticketName)
      ? "vip"
      : rotationCategories[ticketType] ||
        (text(record.Tipo).toLowerCase() === "subscriber" ? "mensualidad" : null);
    return {
      ...record,
      id: JSON.stringify([
        text(record.CodigoTarjeta),
        ticketType,
        record.HoraEntrada ?? null,
        record.HoraSalida ?? null,
        record.TerminalEntrada ?? null,
        record.TerminalSalida ?? null,
      ]),
      entry_at: record.HoraEntrada || null,
      exit_at: record.HoraSalida || null,
      ticket_type: ticketType,
      ticket_label: ticketName,
      ticket_category: category,
    };
  });
}

export function parkingFrequencyEvents(records) {
  return normalizeParkingVisits(records).flatMap((record) => {
    if (!isParkingVisit(record)) return [record];
    return [
      ["GPIN", record.entry_at, record.TerminalEntrada],
      ["GPOUT", record.exit_at, record.TerminalSalida],
    ]
      .filter(([, date]) => date)
      .map(([eventtype, fecha_captura, terminal]) => ({
        id: JSON.stringify([record.id, eventtype]),
        eventtype,
        fecha_captura,
        terminal,
        ticket_type: record.ticket_type,
        ticket_category: record.ticket_category,
        ticket_label: record.ticket_label,
        access_scope: eventtype === "GPIN" ? record.entry_scope : record.exit_scope,
      }));
  });
}

export function parkingTicketTypes(records) {
  const types = new Map();
  records.forEach((record) => {
    if (!isParkingVisit(record)) return;
    const value = text(record.TipoTarjeta),
      label = text(record.NombreTipoTarjeta);
    if (!value || !label) return;
    if (types.has(value) && types.get(value).label !== label)
      throw new Error(`El tipo de tarjeta ${value} tiene nombres contradictorios en la respuesta.`);
    types.set(value, { value, label });
  });
  return [...types.values()].sort((a, b) => a.label.localeCompare(b.label, "es"));
}
